/**
 * Helper to access environment variables in both Vite (browser) and Node.js contexts.
 *
 * In Vite builds, uses `import.meta.env`.
 * In Node.js (e.g., E2E test setup), falls back to `process.env`.
 */
function getEnv(key: string): string | undefined {
  // Check if running in Vite context (import.meta.env exists)
  if (typeof import.meta !== "undefined" && import.meta.env) {
    return import.meta.env[key];
  }
  // Fallback to process.env for Node.js context
  if (typeof process !== "undefined" && process.env) {
    return process.env[key];
  }
  return undefined;
}

export { getEnv };
